var TRACKINGTOOLS = function () {
  this.adapters = [];

  // ============================================================
  this.registerAdapter = function (adapter) {
    if (adapter && typeof adapter.register === "function") {
      this.adapters.push(adapter);
      adapter.register();
    }
  };

  // ============================================================
  this.pageView = function (params = {}) {
    params = {
      page_path: params.page_path ?? location.pathname + location.search,
      page_title: params.page_title ?? document.title,
      page_location: location.href,
      ...params,
    };

    this.adapters.forEach((a, i) => {
      try {
        a.pageView(params);
      } catch (e) {
        console.error("pageView error", e);
      }
    });
  };

  // ============================================================
  this.event = function (eventName, params = {}) {
    this.adapters.forEach((a) => {
      try {
        a.event(eventName, params);
      } catch (e) {
        console.error("event error", e);
      }
    });
  };
};

var trackingTools = new TRACKINGTOOLS();
export default trackingTools;
